import { render, staticRenderFns } from "./BakSelector.vue?vue&type=template&id=8a5612a0&scoped=true"
import script from "./BakSelector.vue?vue&type=script&lang=js"
export * from "./BakSelector.vue?vue&type=script&lang=js"
import style0 from "./BakSelector.vue?vue&type=style&index=0&id=8a5612a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5612a0",
  null
  
)

export default component.exports